import { StanModal } from '@/components';

interface UnscheduleBroadcastModalProps {
    isOpen: boolean;
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const UnscheduleBroadcastModal = ({
    isOpen,
    isLoading = false,
    onConfirm,
    onCancel,
}: UnscheduleBroadcastModalProps) => {
    return (
        <StanModal
            id='unschedule-broadcast-modal'
            isOpen={isOpen}
            onClose={onCancel}
            title='Unschedule Broadcast'
            size='sm'
            primaryActionLabel='Yes, Unschedule'
            secondaryActionLabel='Cancel'
            primaryActionColor='destructive'
            secondaryActionColor='secondary'
            onPrimaryAction={onConfirm}
            onSecondaryAction={onCancel}
            primaryActionDisabled={isLoading}
            primaryActionLoading={isLoading}
            secondaryActionDisabled={isLoading}
            hideCloseButton
        >
            <p className='text-dark text-caption-1-regular text-center'>
                Are you sure you want to save this broadcast as a draft? This will unschedule your send and the
                broadcast will not be sent at the scheduled time.
            </p>
        </StanModal>
    );
};
